import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { BaseHeading as Heading } from '@beef/legacy-ui-kit';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function PopularArticleHeading({ headline, headlineTagName }) {
  return (
    <div className={cx('bar')}>
      {headline ?
        <Heading tagName={headlineTagName} className={cx('headline')}>
          {headline}
        </Heading>
      : null}
    </div>
  );
}

PopularArticleHeading.defaultProps = {
  headline: '',
  headlineTagName: 'div',
};

PopularArticleHeading.propTypes = {
  headline: PropTypes.string,
  headlineTagName: PropTypes.string,
};

export default PopularArticleHeading;
